import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["placeholder", "content"]

  connect() {
    // Show skeleton placeholder until turbo frame loads
    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.classList.remove("hidden")
    }
  }

  loaded() {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches

    if (prefersReduced || !this.hasPlaceholderTarget) {
      // Instant swap for reduced motion or missing placeholder
      if (this.hasPlaceholderTarget) this.placeholderTarget.classList.add("hidden")
      if (this.hasContentTarget) this.contentTarget.classList.remove("hidden")
      return
    }

    // Cross-dissolve: fade out skeleton, fade in content
    const placeholder = this.placeholderTarget
    const content = this.hasContentTarget ? this.contentTarget : null

    placeholder.style.transition = "opacity 150ms ease"
    placeholder.style.opacity = "0"

    if (content) {
      content.classList.remove("hidden")
      content.style.opacity = "0"
      content.style.transition = "opacity 150ms ease"
    }

    // After skeleton fades out, show content
    const cleanup = () => {
      placeholder.classList.add("hidden")
      placeholder.style.transition = ""
      placeholder.style.opacity = ""

      if (content) {
        content.style.opacity = "1"
        // Clean up inline styles after transition
        setTimeout(() => {
          content.style.transition = ""
          content.style.opacity = ""
        }, 160)
      }
    }

    placeholder.addEventListener("transitionend", cleanup, { once: true })
    // Safety fallback — ensure cleanup even if transitionend doesn't fire
    setTimeout(cleanup, 200)
  }
}
